import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, BookOpenCheckIcon, CheckIcon, HeartHandshakeIcon, LanguagesIcon, LockKeyholeIcon, MessageCircleHeartIcon, ShieldCheckIcon, ShoppingBagIcon, SparklesIcon, TimerResetIcon } from 'lucide-react';
import { FaqSection } from './FaqSection';
import { OfferModal } from './OfferModal';
import { PrimaryButton } from './PrimaryButton';
const failedApproaches = ['Usaste “time-outs” que solo hicieron que gritara más fuerte.', 'Le explicaste con frases largas mientras estaba en crisis.', 'Cambiaste al inglés y sentiste que perdías la conexión de tu lengua materna.', 'Seguiste consejos que ignoran el estrés de crecer entre dos idiomas.'];
const inclusions = [['Entendiendo el Cerebro Bilingüe', 'Una guía cálida y práctica para comprender emociones, comunicación y berrinches.'], ['Emergency Bilingual Scripts', 'Frases exactas en ES/EN para el súper, casa de los abuelos o parque.'], ['The 3-Word Rule Tutorial', 'La regla breve que le da a su cerebro una idea clara a la vez.'], ['Public Panic Protocol', 'Qué decir a extraños que miran para recuperar tu calma y control.'], ['Digital Cheat Sheets', 'Hojas de acceso rápido para guardar en tu celular y abrir en segundos.']];
const fitPoints = ['Eres mamá latina en USA con un niño de 18 meses a 4 años.', 'Quieres criar en dos idiomas con claridad, no con culpa.', 'Buscas una crianza respetuosa que también sea práctica.'];
const notFitPoints = ['Buscas disciplina física o métodos punitivos.', 'No te interesa fomentar el bilingüismo.', 'Quieres una solución mágica sin ajustar cómo hablas en crisis.'];
export function LandingPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <div className="min-h-screen w-full overflow-hidden bg-[#fffaf0] text-[#3c2b23]" data-id="element-13">
      <header className="border-b border-[#e7dccb] bg-[#fffaf0]/95" data-id="element-14">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 sm:px-8" data-id="element-15">
          <a href="#inicio" className="font-serif text-xl font-bold tracking-tight text-[#3c2b23]" data-id="element-16">
            Dos Raíces<span className="text-[#a84b35]" data-id="element-17">.</span>
          </a>
          <button type="button" onClick={scrollToOffer} className="rounded-full border border-[#3c2b23] px-4 py-2 text-xs font-bold tracking-wide text-[#3c2b23] transition hover:bg-[#3c2b23] hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[#a84b35] sm:px-5" data-id="element-18">
            Ver la guía
          </button>
        </div>
      </header>

      <main id="inicio" data-id="element-19">
        <section className="relative mx-auto max-w-6xl px-5 pb-16 pt-14 sm:px-8 sm:pb-24 sm:pt-20" data-id="element-20">
          <div className="grid items-center gap-12 lg:grid-cols-[1.05fr_.95fr]" data-id="element-21">
            <motion.div initial={{
            opacity: 0,
            y: 18
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.45
          }} data-id="element-22">
              <p className="eyebrow" data-id="element-23">GUÍA PRÁCTICA PARA HOGARES BILINGÜES</p>
              <h1 className="mt-5 max-w-3xl font-serif text-5xl leading-[0.97] tracking-[-0.04em] text-[#3c2b23] sm:text-6xl lg:text-7xl" data-id="element-24">
                Detén los berrinches de{' '}
                <span className="text-[#a84b35]" data-id="element-25">“no sé qué quiere”</span> en 30
                segundos.
              </h1>
              <p className="mt-6 max-w-xl text-lg leading-8 text-[#6a584d] sm:text-xl" data-id="element-26">
                Incluso si tu hijo mezcla el inglés y el español. La primera
                guía bilingüe diseñada para mamás latinas en USA que quieren
                recuperar la paz en casa.
              </p>
              <div className="mt-8" data-id="element-27">
                <PrimaryButton onClick={scrollToOffer} data-id="element-28">
                  Quiero la guía ahora
                </PrimaryButton>
                <p className="mt-4 flex items-center gap-2 text-sm text-[#6a584d]" data-id="element-29">
                  <LockKeyholeIcon className="h-4 w-4 text-[#72846b]" aria-hidden="true" data-id="element-30" />
                  Acceso instantáneo · Compra segura y privada
                </p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            rotate: 2,
            y: 12
          }} animate={{
            opacity: 1,
            rotate: 2,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.12
          }} className="relative mx-auto w-full max-w-md" data-id="element-31">
              <div className="rounded-[2rem] border border-[#d5c5af] bg-[#eadfce] p-4 shadow-[10px_12px_0_#72846b]" data-id="element-32">
                <div className="relative isolate overflow-hidden rounded-[1.3rem] px-7 py-9 sm:px-10" data-id="element-33">
                  <img src="https://cdn.magicpatterns.com/uploads/xvaXunPC4YaaA8BDWWAb3n/1.png" alt="" className="absolute inset-0 -z-20 h-full w-full object-cover" data-id="element-34" />
                  <div className="absolute inset-0 -z-10 bg-[#2c1f1a]/65" aria-hidden="true" data-id="element-35" />
                  <div className="flex items-center justify-between" data-id="element-36">
                    <LanguagesIcon className="h-7 w-7 text-[#fffaf0]" aria-hidden="true" data-id="element-37" />
                    <span className="rounded-full bg-[#fffaf0]/90 px-3 py-1 text-[10px] font-bold tracking-[0.15em] text-[#50654c]" data-id="element-38">
                      ES + EN
                    </span>
                  </div>
                  <p className="mt-12 font-serif text-3xl leading-none text-white" data-id="element-39">
                    Entendiendo
                  </p>
                  <p className="font-serif text-3xl leading-none text-white" data-id="element-40">
                    el Cerebro
                  </p>
                  <p className="font-serif text-3xl leading-none text-[#f3c1aa]" data-id="element-41">
                    Bilingüe
                  </p>
                  <div className="mt-8 border-t border-white/40 pt-4 text-xs font-bold uppercase tracking-[0.12em] text-[#fffaf0]" data-id="element-42">
                    de tu hijo
                  </div>
                  <div className="mt-10 flex items-end justify-between" data-id="element-43">
                    <span className="text-xs text-[#fffaf0]" data-id="element-44">
                      La guía de respuesta rápida
                    </span>
                    <HeartHandshakeIcon className="h-8 w-8 text-[#e7efe1]" aria-hidden="true" data-id="element-45" />
                  </div>
                </div>
              </div>
              <div className="absolute -bottom-6 -left-5 rounded-2xl border border-[#d5c5af] bg-[#fffaf0] px-4 py-3 shadow-lg sm:-left-10" data-id="element-46">
                <p className="text-[10px] font-bold tracking-[0.13em] text-[#a84b35]" data-id="element-47">
                  MIRROR-SCRIPT™
                </p>
                <p className="mt-1 font-serif text-xl" data-id="element-48">“Te veo. Estoy aquí.”</p>
              </div>
            </motion.div>
          </div>
        </section>

        <section className="bg-[#3c2b23] px-5 py-16 text-[#fffaf0] sm:px-8 sm:py-20" data-id="element-49">
          <div className="mx-auto max-w-4xl" data-id="element-50">
            <p className="eyebrow text-[#e9b19b]" data-id="element-51">TE VEO, MAMÁ</p>
            <h2 className="mt-4 font-serif text-4xl leading-tight sm:text-5xl" data-id="element-52">
              La fila de Target no debería sentirse como un juicio.
            </h2>
            <div className="mt-8 border-l-2 border-[#d8785e] pl-6 text-lg leading-8 text-[#f0e5d5] sm:text-xl" data-id="element-53">
              Estás en la fila. Tu hijo grita, se tira al suelo y el calor te
              sube a la cara. Intentas calmarlo en español, pero parece no
              escucharte. Miras alrededor y sientes las miradas.
            </div>
            <p className="mt-8 text-lg leading-8 text-[#d6c4b1]" data-id="element-54">
              No eres una “mala madre” y tu hijo no es “malcriado”. Es el{' '}
              <strong className="font-bold text-[#fffaf0]" data-id="element-55">
                cortocircuito bilingüe
              </strong>
              : un cerebro pequeño intentando procesar dos mundos mientras
              colapsa por no saber explicarse.
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-5 py-20 sm:px-8" data-id="element-56">
          <div className="grid gap-12 lg:grid-cols-2" data-id="element-57">
            <div data-id="element-58">
              <p className="eyebrow" data-id="element-59">EL NIVEL EXTRA QUE NADIE TE CUENTA</p>
              <h2 className="mt-3 font-serif text-4xl leading-tight sm:text-5xl" data-id="element-60">
                Criar entre dos culturas también cansa.
              </h2>
              <p className="mt-6 text-lg leading-8 text-[#6a584d]" data-id="element-61">
                Los libros en inglés se sienten fríos. Los consejos de la
                familia —“dale un manazo”— ya no resuenan con la mamá que
                quieres ser. Entre traducir emociones y cargar con culpa, la
                falta de comunicación puede abrir una distancia que duele cada
                noche.
              </p>
            </div>
            <aside className="rounded-[2rem] border border-[#dfd0bc] bg-[#f5ecdf] p-7 sm:p-9" data-id="element-62">
              <p className="text-sm font-bold uppercase tracking-[0.14em] text-[#a84b35]" data-id="element-63">
                Si ya intentaste de todo…
              </p>
              <ul className="mt-5 space-y-5" data-id="element-64">
                {failedApproaches.map(item => <li key={item} className="flex gap-3 text-[15px] leading-6 text-[#58483e]" data-id="element-65">
                    <span className="mt-1.5 h-2 w-2 flex-none rounded-full bg-[#a84b35]" aria-hidden="true" data-id="element-66" />
                    {item}
                  </li>)}
              </ul>
            </aside>
          </div>
        </section>

        <section className="bg-[#e7efe1] px-5 py-20 sm:px-8" data-id="element-67">
          <div className="mx-auto max-w-6xl" data-id="element-68">
            <div className="max-w-3xl" data-id="element-69">
              <p className="eyebrow text-[#50654c]" data-id="element-70">UNA RESPUESTA DIFERENTE</p>
              <h2 className="mt-3 font-serif text-4xl leading-tight sm:text-5xl" data-id="element-71">
                No le pidas que razone cuando su cerebro está en alarma.
              </h2>
              <p className="mt-6 text-lg leading-8 text-[#53634f]" data-id="element-72">
                El Método Espejo™ es un sistema bilingüe de respuesta rápida.
                Usas frases puente de tres palabras que le dan la palabra exacta
                que necesita, en ambos idiomas, antes de que la frustración tome
                el mando.
              </p>
            </div>
            <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-73">
              {[['1', 'Nombra lo que ve', '“Quieres más tiempo.”'], ['2', 'Refleja su emoción', '“Estás muy triste.”'], ['3', 'Da una salida', '“Vamos juntas, mamá.”']].map(([number, title, script]) => <article key={number} className="rounded-3xl bg-[#fffaf0] p-6 shadow-sm" data-id="element-74">
                  <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#72846b] text-sm font-bold text-white" data-id="element-75">
                    {number}
                  </span>
                  <h3 className="mt-6 text-xl font-bold" data-id="element-76">{title}</h3>
                  <p className="mt-3 font-serif text-2xl text-[#a84b35]" data-id="element-77">
                    {script}
                  </p>
                </article>)}
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-5 py-20 sm:px-8" data-id="element-78">
          <div className="max-w-2xl" data-id="element-79">
            <p className="eyebrow" data-id="element-80">DENTRO DE LA GUÍA</p>
            <h2 className="mt-3 font-serif text-4xl leading-tight sm:text-5xl" data-id="element-81">
              Palabras listas cuando más las necesitas.
            </h2>
          </div>
          <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-82">
            {inclusions.map(([title, description]) => <article key={title} className="rounded-3xl border border-[#e1d4c1] bg-white/50 p-6" data-id="element-83">
                <BookOpenCheckIcon className="h-7 w-7 text-[#a84b35]" aria-hidden="true" data-id="element-84" />
                <h3 className="mt-5 text-lg font-bold text-[#3c2b23]" data-id="element-85">
                  {title}
                </h3>
                <p className="mt-3 text-sm leading-6 text-[#6a584d]" data-id="element-86">
                  {description}
                </p>
              </article>)}
          </div>
        </section>

        <section className="bg-[#f5ecdf] px-5 py-20 sm:px-8" data-id="element-87">
          <div className="mx-auto grid max-w-6xl gap-8 md:grid-cols-2" data-id="element-88">
            <article className="rounded-[2rem] bg-[#fffaf0] p-8" data-id="element-89">
              <BadgeCheckIcon className="h-9 w-9 text-[#72846b]" aria-hidden="true" data-id="element-90" />
              <h2 className="mt-5 font-serif text-3xl" data-id="element-91">
                Esta guía es para ti si…
              </h2>
              <ul className="mt-6 space-y-4" data-id="element-92">
                {fitPoints.map(point => <ListItem key={point} text={point} positive data-id="element-93" />)}
              </ul>
            </article>
            <article className="rounded-[2rem] border border-[#dacbb6] p-8" data-id="element-94">
              <h2 className="font-serif text-3xl" data-id="element-95">No es para ti si…</h2>
              <ul className="mt-6 space-y-4" data-id="element-96">
                {notFitPoints.map(point => <ListItem key={point} text={point} data-id="element-97" />)}
              </ul>
            </article>
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-5 py-20 sm:px-8" data-id="element-98">
          <div className="text-center" data-id="element-99">
            <p className="eyebrow" data-id="element-100">SIMPLE. AMABLE. PRÁCTICO.</p>
            <h2 className="mt-3 font-serif text-4xl sm:text-5xl" data-id="element-101">
              Tu nueva respuesta en 3 pasos.
            </h2>
          </div>
          <div className="mt-12 grid gap-8 md:grid-cols-3" data-id="element-102">
            <Step icon={<ShoppingBagIcon data-id="element-104" />} number="01" title="Descarga" text="Obtienes acceso inmediato al PDF y las tarjetas para tu celular." data-id="element-103" />
            <Step icon={<SparklesIcon data-id="element-106" />} number="02" title="Identifica" text="Usas el diccionario de gestos para entender qué necesita antes de que grite." data-id="element-105" />
            <Step icon={<MessageCircleHeartIcon data-id="element-108" />} number="03" title="Aplica" text="Usas los Mirror-Scripts™ de 3 palabras para calmar el momento." data-id="element-107" />
          </div>
        </section>

        <section className="bg-[#72846b] px-5 py-16 text-[#fffaf0] sm:px-8 sm:py-20" data-id="element-109">
          <div className="mx-auto max-w-4xl text-center" data-id="element-110">
            <TimerResetIcon className="mx-auto h-10 w-10 text-[#f3d1bd]" aria-hidden="true" data-id="element-111" />
            <h2 className="mt-5 font-serif text-4xl leading-tight sm:text-5xl" data-id="element-112">
              En 7 días puedes sentir un cambio real.
            </h2>
            <p className="mt-6 text-lg leading-8 text-[#f5f1e6]" data-id="element-113">
              Los gritos disminuyen cuando tu hijo se siente visto. No es magia:
              es una forma clara de acompañar su cerebro bilingüe. Cambia la
              vergüenza en público por la confianza de saber qué decir.
            </p>
          </div>
        </section>

        <FaqSection data-id="element-114" />

        <section id="oferta" className="bg-[#3c2b23] px-5 py-20 text-[#fffaf0] sm:px-8" data-id="element-115">
          <div className="mx-auto max-w-3xl text-center" data-id="element-116">
            <p className="eyebrow text-[#e9b19b]" data-id="element-117">ACCESO INMEDIATO</p>
            <h2 className="mt-4 font-serif text-4xl leading-tight sm:text-5xl" data-id="element-118">
              Recupera la conexión con tu hijo hoy mismo.
            </h2>
            <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-[#e4d4c3]" data-id="element-119">
              Por el precio de un café en Starbucks, llévate una herramienta
              hecha para tu hogar bilingüe.
            </p>
            <div className="mx-auto mt-9 max-w-md rounded-[2rem] bg-[#fffaf0] p-8 text-[#3c2b23] shadow-xl" data-id="element-120">
              <p className="text-sm font-bold uppercase tracking-[0.16em] text-[#a84b35]" data-id="element-121">
                Inversión única
              </p>
              <p className="mt-1 font-serif text-6xl" data-id="element-122">
                $6<span className="text-3xl" data-id="element-123">,36</span>
              </p>
              <p className="text-sm text-[#6a584d]" data-id="element-124">USD · Sin suscripciones</p>
              <PrimaryButton className="mt-7 w-full sm:w-full" onClick={() => setIsModalOpen(true)} data-id="element-125">
                Quiero la guía “Cerebro Bilingüe” ahora
              </PrimaryButton>
              <p className="mt-5 flex justify-center gap-2 text-xs text-[#6a584d]" data-id="element-126">
                <ShieldCheckIcon className="h-4 w-4 text-[#72846b]" aria-hidden="true" data-id="element-127" />
                Tu compra es segura y privada.
              </p>
            </div>
          </div>
        </section>
      </main>

      <footer className="bg-[#2c1f1a] px-5 py-8 text-center text-sm text-[#cdbdad]" data-id="element-128">
        Dos Raíces · Una guía hecha con respeto para familias bilingües.
      </footer>

      <OfferModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-129" />
    </div>;
}
type ListItemProps = {
  text: string;
  positive?: boolean;
};
function ListItem({
  text,
  positive = false
}: ListItemProps) {
  return <li className="flex gap-3 text-[15px] leading-6 text-[#58483e]" data-id="element-130">
      {positive ? <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-[#72846b]" data-id="element-131" /> : <span className="mt-2 h-1.5 w-1.5 flex-none rounded-full bg-[#a84b35]" data-id="element-132" />}
      {text}
    </li>;
}
type StepProps = {
  icon: React.ReactNode;
  number: string;
  title: string;
  text: string;
};
function Step({
  icon,
  number,
  title,
  text
}: StepProps) {
  return <article className="relative border-t-2 border-[#a84b35] pt-6" data-id="element-133">
      <span className="absolute right-0 top-5 text-sm font-bold text-[#baa994]" data-id="element-134">
        {number}
      </span>
      <div className="text-[#a84b35]" data-id="element-135">{icon}</div>
      <h3 className="mt-5 font-serif text-3xl" data-id="element-136">{title}</h3>
      <p className="mt-3 max-w-xs leading-7 text-[#6a584d]" data-id="element-137">{text}</p>
    </article>;
}